module.exports = __webpack_public_path__ + "img/howItWorksTablet.29a1b111.png";